/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from '../../../styles/partials/online-tag.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const OnlineTag = ({ className }) => (
    <div className={classNames([styles.container, { [className]: className !== null }])}>
        <FormattedMessage defaultMessage="Online" description="Tag label" />
    </div>
);
OnlineTag.propTypes = propTypes;
OnlineTag.defaultProps = defaultProps;

export default OnlineTag;
